export const EventStatusFilter = [
  { value: "archive", label: "Archive" },
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];
